import getUploadUrl from './getUploadUrl';

export default {
  getUploadUrl,
};
